import { XMarkIcon } from '@heroicons/react/24/outline';
import { useMemo } from 'react';
import { clientFormatDateTimeLong } from '~/public/lib/ClientDateTime.js';

const ClassSelectionSummary = ({
    selectedClasses,
    selectedClassMetadata,
    onRemoveClass,
    settings,
    className,
    clientTz,
}) => {
    if ((selectedClasses || []).filter(s => !!s.startTime).length === 0) {
        return null;
    }

    const selectedClassWithMetadata = useMemo(() => {
        return selectedClasses.map(selected => {
            const metadata = selectedClassMetadata.find(
                m =>
                    m.event_type_id === selected.eventType &&
                    m.bookable_resource_id === selected.bookableResource,
            );

            return {
                ...metadata,
                ...selected,
            };
        });
    }, [selectedClasses, selectedClassMetadata]);

    return (
        <div className={className}>
            <div className="panel-label">Selected Times</div>
            <div className="bg-white border border-gray-300 rounded-lg pl-6">
                {selectedClassWithMetadata.map((selected, idx) => (
                    <div
                        key={idx}
                        className={`pr-6 py-6 flex items-center justify-between ${idx > 0 ? 'border-t' : ''}`}
                    >
                        <div className="flex items-center">
                            {selected.event_type?.name}{' '}
                            {!!selected.bookable_resource?.name &&
                                !settings?.hideBookableResource && (
                                    <>({selected.bookable_resource?.name}) </>
                                )}
                            <div className="ml-2 text-gray-500">
                                {clientFormatDateTimeLong(
                                    selected.startTime,
                                    clientTz,
                                )}
                            </div>
                        </div>
                        <button
                            type="button"
                            className="text-red-600"
                            onClick={() => onRemoveClass(selected)}
                        >
                            <XMarkIcon className="w-5 h-5" />
                        </button>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default ClassSelectionSummary;
